//@ts-strict-ignore
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import borderMixin from '../../../styles/utils/borderMixin';
import { useSymbolFromCurrency } from '../../../utils/CurrencyUtil';
import { usePrecision } from '../../../utils/hooks';

const fontSize = ({ view, fontSize }) => {
  let size = view ? '17px' : '14px';
  if (fontSize) size = fontSize;
  return `
    font-size: ${size};
  `;
};

const fontColor = ({ primary, link, theme }) => {
  let color: string;
  if (link) {
    color = theme.colors.inputBorderHover;
  } else {
    color = primary ? '#212B36' : theme.colors.inputControl;
  }
  return `
    color: ${color};
  `;
};

const Div: any = styled.div`
  display: inline-block;
  width: 100%;
  padding: ${(props: any) => (props.iconSuffix ? '0px 32px 0px 0px' : '0')};
  ${fontSize}
  font-weight:${(props: any) => (props.primary ? '500' : '400')};
  ${fontColor}
  vertical-align:${(props: any) => (props.verticalAlign ? props.verticalAlign : 'middle')};
  line-height: inherit;
  min-height: 20px;
  text-align: ${(props: any) => (props.align === 'left' ? 'left' : 'right')};
  ${borderMixin} &:disabled {
    cursor: not-allowed;
  }
  &:hover {
    color: ${(props) => (props.link ? props.theme.colors.inputBorderHover : props.theme.colors.inputControl)};
    text-decoration: ${(props) => (props.link ? 'underline' : 'none')};
  }
` as any;

export type IValueProps = {
  decimals?: number;
  iconSuffix?: boolean;
  primary?: boolean;
  type?: 'currency' | 'text' | 'baseCurrency' | 'number';
  valueType?: 'sales' | 'cost';
  view?: boolean;
  readOnly?: boolean;
  align?: string;
  verticalAlign?: string;
  onClick?: Function;
  testId?: string;
  value: string | number;
};

const Value = (props) => {
  const {
    decimals,
    iconSuffix,
    primary,
    type,
    valueType, //'sales' or 'cost'
    view,
    readOnly,
    align,
    link,
    fontSize,
    verticalAlign,
    onClick,
    testId,
    value,
  } = props;

  const precision = usePrecision(valueType);

  let valueToDisplay: any = value;
  if (type === 'text') {
    if (!value) {
      valueToDisplay = '';
    } else if (props.initialCaps) {
      valueToDisplay = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }
  } else {
    if (value === '' || !value) valueToDisplay = 0;
    if ((decimals !== null || type === 'currency' || type === 'baseCurrency') && typeof props.value === 'number') {
      valueToDisplay = value.toFixed(decimals ?? precision);
    }
  }

  const currencySymbol = useSymbolFromCurrency(type, value);

  return (
    <Div
      data-testid={testId}
      primary={primary}
      view={view}
      align={align}
      readOnly={readOnly}
      iconSuffix={iconSuffix}
      link={link}
      fontSize={fontSize}
      verticalAlign={verticalAlign}
      onClick={onClick}
    >
      {currencySymbol}
      {currencySymbol && currencySymbol?.length > 1 ? ' ' : ''}
      {valueToDisplay}
    </Div>
  );
};

Value.propTypes = {
  type: PropTypes.string.isRequired,
  iconSuffix: PropTypes.bool,
  initialCaps: PropTypes.bool,
};
Value.defaultProps = {
  type: 'numeric',
  iconSuffix: false,
  initialCaps: false,
};

export default Value;
